<template>
  <!-- sm:w-1/2 lg:w-1/4 w-full -->
  <div class="group rounded-2xl relative flex flex-col h-full p-2">
    <div
      class="hover-hover:group-hover:bg-brand hover-hover:group-hover:text-white rounded-2xl min-h-56 flex flex-col mb-2 border border-brand transition-colors duration-200"
    >
      <div
        class="flex items-center p-2 border-b border-brand hover-hover:group-hover:border-white"
      >
        <h3
          v-text="Title"
          class="text-primary hover-hover:group-hover:text-white text-2xl uppercase"
        />
        <span class="flex-1" />
        <p class="leading-3 text-center">
          <span class="text--barred whitespace-pre">{{
            `   ${BaseFee}€   `
          }}</span
          ><br /><span class="text-sm">al mese</span>
        </p>
      </div>
      <div
        class="flex items-center p-2 border-b border-brand hover-hover:group-hover:border-white"
      >
        <p
          class="text-primary rounded-xl hover-hover:group-hover:bg-white px-2 py-1 mr-1 border"
        >
          <span class="text-2xl font-black">{{ FinalFee }}</span
          ><span class="text-base">€</span>
        </p>
        <p class=" text-sm leading-tight">
          al mese
          <br />
          con l'accredito dello stipendio/pensione
        </p>
        <span class="flex-1" />
      </div>
      <div class="p-2 mb-auto prose-sm prose" v-html="SmallDescription" />
    </div>
    <div
      @click="goToDetail(PackageId)"
      class="hover-hover:group-hover:bg-accent hover-hover:group-hover:text-brand rounded-2xl p-2 text-center uppercase border cursor-pointer bg-brand text-white transition-colors duration-200"
    >
      Scopri di più
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Title: String,
    BaseFee: Number,
    FinalFee: Number,
    SmallDescription: String,
    Description: String,
    PackageId: String
  },
  data: () => ({
    openInfo: Boolean()
  }),
  methods: {
    onClickAway() {
      if (this.openInfo === true) {
        this.openInfo = false;
      }
    },
    goToDetail(id) {
      const route = this.isDesktop
        ? "pacchetti/confrontaconti"
        : `pacchetti/confrontaconti/${id}`;
      this.$router.push(route);
    }
  }
};
</script>

<style></style>

<style scoped>
.text--barred {
  @apply line-through;
  text-decoration-color: theme("colors.primary");
}
.group:hover .text--barred {
  text-decoration-color: theme("colors.white");
}
</style>
